import { createPortal } from 'react-dom';
import { useMessage, useNotification } from '../hooks';
import { MessagePositions } from './molecules/MessagePositions';
import { NotificationPositions } from './molecules/NotificationPositions';

/**
 * Componente unificado que renderiza tanto toasts como notificaciones
 * @example
 * function App() {
 *   return (
 *     <>
 *       <Messaging />
 *       {children}
 *     </>
 *   )
 * }
 */
export const Messaging = () => {
  const { messagesByPosition } = useMessage();
  const { groups } = useNotification();

  return createPortal(
    <>
      <MessagePositions messages={messagesByPosition} />
      <NotificationPositions groups={groups} />
    </>,
    document.body,
  );
};
